import api from "./api";

function authHeaders() {
  const token = localStorage.getItem("tk446655440000");
  const headers = {
    "Content-Type": "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
  const websiteCode = (process.env.REACT_APP_WEBSITE_CODE || "").trim();
  if (websiteCode) headers["X-Website-Code"] = websiteCode;
  return headers;
}

function normalizeCommandResponse(data) {
  if (data == null) return { success: false, errorCode: "EXECUTE_FAILED", message: "Empty response" };
  const message =
    data.message ??
    data.Message ??
    data.title ??
    data.Title ??
    data.detail ??
    data.Detail ??
    "";
  return {
    success: data.success ?? data.Success ?? false,
    command: data.command ?? data.Command ?? null,
    summary: data.summary ?? data.Summary ?? null,
    confirmToken: data.confirmToken ?? data.ConfirmToken ?? null,
    expiresInSeconds: Number(data.expiresInSeconds ?? data.ExpiresInSeconds ?? 120),
    warnings: data.warnings ?? data.Warnings ?? [],
    message,
    result: data.result ?? data.Result ?? null,
    auditId: data.auditId ?? data.AuditId ?? null,
    errorCode: data.errorCode ?? data.ErrorCode ?? null,
    data: data.data ?? data.Data ?? null,
    stats: data.stats ?? data.Stats ?? null,
    traceId: data.traceId ?? data.TraceId ?? null,
    httpStatus: data.httpStatus ?? data.HttpStatus ?? null,
  };
}

function toErrorResult(err) {
  const body = err?.response?.data;
  const httpStatus = err?.response?.status ?? null;
  if (body && typeof body === "object") {
    return normalizeCommandResponse({ ...body, httpStatus });
  }
  return {
    success: false,
    errorCode: "EXECUTE_FAILED",
    message: err?.message || "Request failed",
    httpStatus,
    warnings: [],
  };
}

/**
 * POST /Assistant/commands/preview — no write.
 * @param {{ command: string, payload: object }} body
 */
export async function previewAssistantCommand(body) {
  try {
    const { data } = await api.post("/Assistant/commands/preview", body, { headers: authHeaders() });
    return normalizeCommandResponse(data);
  } catch (err) {
    return toErrorResult(err);
  }
}

/**
 * POST /Assistant/commands/execute — write once.
 * @param {{ confirmToken: string, command?: string }} body
 */
export async function executeAssistantCommand(body) {
  try {
    const { data } = await api.post("/Assistant/commands/execute", body, { headers: authHeaders() });
    return normalizeCommandResponse(data);
  } catch (err) {
    return toErrorResult(err);
  }
}

/**
 * GET /Assistant/commands/history
 */
export async function fetchAssistantCommandHistory({ pageNumber = 1, pageSize = 20, allUsers = false } = {}) {
  try {
    const { data } = await api.get("/Assistant/commands/history", {
      params: { pageNumber, pageSize, ...(allUsers ? { allUsers: true } : {}) },
      headers: authHeaders(),
    });
    return normalizeCommandResponse(data);
  } catch (err) {
    return toErrorResult(err);
  }
}
